import { Button, ButtonProps } from "antd";
import React from "react";
import CustomPopconfirm from "../Popover/CustomPopconfirm";
import scrollToFieldIfVisible from "../../utils/scrollToFieldIfVisible";

interface FormBuilderValidateOnSubmitButtonProps extends ButtonProps {
	form: any;
	labelText?: string;
	handleFormSave?: (data: any) => void;
	isLoading?: boolean;
	onValidationError?: (error: unknown) => void;
	confirmTitle?: React.ReactNode;
}

const FormBuilderValidateOnSubmitButton = React.forwardRef<
	HTMLButtonElement,
	FormBuilderValidateOnSubmitButtonProps
>((props, ref) => {
	const {
		form,
		labelText,
		handleFormSave,
		isLoading,
		onValidationError,
		confirmTitle,
		...buttonProps
	} = props;

	const validateAndSave = async () => {
		try {
			await form.formRef.validateFields();
			if (handleFormSave) {
				handleFormSave(form.formData);
			}
		} catch (error: any) {
			if (error?.errorFields?.length > 0) {
				const firstError = error.errorFields[0];
				const fieldName = Array.isArray(firstError.name)
					? firstError.name
					: [firstError.name];

				// Scroll to the first invalid field
				scrollToFieldIfVisible(form.formRef, fieldName, {
					behavior: "smooth",
					block: "center",
				});

				// Find and highlight the field element
				const fieldElement = document.querySelector(
					`[name="${fieldName.join(".")}"], [id="${fieldName.join(".")}"]`
				);
				if (fieldElement) {
					fieldElement.classList.add("custom-field-error");
					// Remove highlight after 3 seconds
					setTimeout(() => {
						fieldElement.classList.remove("custom-field-error");
					}, 3000);
				}
				if (onValidationError) {
					onValidationError(error);
				}
			}
		}
	};

	const button = (
		<Button
			ref={ref}
			{...buttonProps}
			type={props.type || "primary"}
			htmlType="button"
			disabled={isLoading}
			onClick={confirmTitle ? undefined : validateAndSave}
		>
			{labelText || "Save"}
		</Button>
	);

	if (confirmTitle) {
		return (
			<CustomPopconfirm title={confirmTitle} handleConfirm={validateAndSave}>
				{button}
			</CustomPopconfirm>
		);
	}

	return button;
});

export default FormBuilderValidateOnSubmitButton;
